/**
 * Timeout duration constants for API requests
 */

export const TIMEOUT = {
  /** Default timeout for standard API requests (30 seconds) */
  DEFAULT_MS: 30 * 1000,
  /** Timeout for status polling requests (10 seconds) */
  POLLING_MS: 10 * 1000,
  /** Timeout for the terms gate check on the path to first paint (10 seconds) */
  GATE_CHECK_MS: 10 * 1000,
} as const;
